import React from 'react';
import PropTypes from 'prop-types';
import { GlobeAmericasIcon, GlobeAltIcon, MapIcon, MapPinIcon } from '@heroicons/react/24/outline';
import DropdownFilter from '@/components/DropdownFilter';

export const ANYWHERE_RADIUS = 99999;
export const ANYWHERE_ID = 'anywhere';

export const RADIUS_OPTIONS = [
  { id: 'le-10',
    radius: 10,
    icon: MapPinIcon,
    title: '10 miles',
    subtitle: 'Show results within 10 miles',
    operator: '<='
  },
  { id: 'le-50',
    radius: 50,
    icon: MapIcon,
    title: '50 miles',
    subtitle: 'Show results within 50 miles',
    operator: '<='
  },
  { id: 'ge-50',
    radius: 50,
    icon: GlobeAltIcon,
    title: '50+ miles',
    subtitle: 'Show results greater than 50 miles away',
    operator: '>='
  },
  { id: ANYWHERE_ID,
    radius: ANYWHERE_RADIUS,
    icon: GlobeAmericasIcon,
    title: 'Anywhere',
    subtitle: 'Show all results regardless of distance.',
    operator: '<'
  },
];

// Shape persisted in the `locationCondition` query param. The "anywhere" option
// omits radius/operator so it reads as "no distance constraint" downstream.
export function toLocationCondition(option) {
  if (option.id === ANYWHERE_ID) {
    return { id: ANYWHERE_ID };
  }

  return {
    id: option.id,
    radius: option.radius,
    radiusOperator: option.operator
  };
}

export default function DistanceFilter(props) {
  const {
    selectedId,
    onChange,
    label,
    subtitle = 'Distance:',
    radiusOptions = RADIUS_OPTIONS,
  } = props;

  const anywhereOption = radiusOptions.find((option) => option.id === ANYWHERE_ID);

  const selectedOption = radiusOptions.find((option) => option.id === selectedId) || anywhereOption;

  return (
    <DropdownFilter
      label={label}
      subtitle={subtitle}
      title={selectedOption?.title}
      count={selectedOption && selectedOption.id !== ANYWHERE_ID ? 1 : 0}
    >
      {radiusOptions.map((option) => (
        <DropdownFilter.MenuItem
          key={option.id}
          icon={option.icon}
          title={option.title}
          subtitle={option.subtitle}
          selected={option.id === selectedOption?.id}
          onClick={() => onChange(option)}
        />
      ))}
    </DropdownFilter>
  );
}

DistanceFilter.propTypes = {
  selectedId: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  subtitle: PropTypes.string,
  radiusOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      radius: PropTypes.number.isRequired,
      icon: PropTypes.elementType,
      title: PropTypes.string.isRequired,
      subtitle: PropTypes.string,
      operator: PropTypes.string,
    })
  ),
};
